module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Knife#2-b75ac162a31fc3dfb2b7cc6a3cdec1f7.svg";